'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  staging: {
    isProduction: true
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  db: process.env.DB || {
    'ip': '10.110.4.203',
    'port': '20002',
    'bdName': 'google_drive',
    'url': 'mongodb://10.110.4.203:20002/google_drive'
  },
  baseUrl: process.env.BASE_URL || 'http://localhost/webdocs/guerra-mentira',
  project: process.env.PROJECT || 'webdocs/guerra-mentira',
  app: {
    title: 'Guerra a la Mentira',
    description: 'Guerra a la Mentira.',
    head: require('./metadata.json')
  },
  urlTraduction: {
    'quien-bombardeo-hogar-omran': 'who-bombed-omran-home',
    'quien-derribo-mh17': 'who-downed-mh17',
    'quien-destruyo-convoy-humanitario': 'who-destroyed-the-humanitarian-convoy',
    'quien-hace-estas-verificaciones': 'who-verified-internationtal-wars',
    'documental': 'documentary',
    'tutoriales': 'tutorials',
    'creditos': 'credits',
    'who-bombed-omran-home': 'quien-bombardeo-hogar-omran',
    'who-downed-mh17': 'quien-derribo-mh17',
    'who-destroyed-the-humanitarian-convoy': 'quien-destruyo-convoy-humanitario',
    'who-verified-internationtal-wars': 'quien-hace-estas-verificaciones',
    'documentary': 'documental',
    'tutorials': 'tutoriales',
    'credits': 'creditos'
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 152
// module chunks = 0